import { Ref, ref } from "vue";

export function useRotation(elementRef: Ref<HTMLElement | null>) {
  const rotateAngle = ref(0);
  const isDragging = ref(false);

  function startRotation(e: MouseEvent | TouchEvent) {
    e.preventDefault();
    isDragging.value = true;
    window.addEventListener("mousemove", rotate);
    window.addEventListener("mouseup", stopRotation);
    window.addEventListener("touchmove", rotate);
    window.addEventListener("touchend", stopRotation);
  }

  function stopRotation() {
    isDragging.value = false;
    window.removeEventListener("mousemove", rotate);
    window.removeEventListener("mouseup", stopRotation);
    window.removeEventListener("touchmove", rotate);
    window.removeEventListener("touchend", stopRotation);
  }

  function rotate(e: MouseEvent | TouchEvent) {
    if (!elementRef.value || !isDragging.value) return;

    const clientX = "touches" in e ? e.touches[0].clientX : e.clientX;
    const clientY = "touches" in e ? e.touches[0].clientY : e.clientY;

    const rect = elementRef.value.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const rad = Math.atan2(clientY - cy, clientX - cx);
    const deg = rad * (180 / Math.PI);
    rotateAngle.value = (deg + 90 + 360) % 360;

    elementRef.value.style.transform = `translate(-50%, -50%) rotate(${
      deg + 90
    }deg)`;
  }

  return { rotateAngle, isDragging, startRotation };
}
